import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';
import { BASE_URL } from '../../utils/constants';
import { getErrorMessage } from '../../utils/helper';

const CONFIG_ENDPOINT = 'config';

// Fetch Config
export const fetchConfig = createAsyncThunk(
  'config/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`${BASE_URL}${CONFIG_ENDPOINT}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to fetch config'));
    }
  }
);

// Update Config
export const updateConfig = createAsyncThunk(
  'config/update',
  async (configData, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put(`${BASE_URL}${CONFIG_ENDPOINT}`, configData);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to update config'));
    }
  }
); 